const MONITORING_SCOPE = 'MONITORING_SCOPE';

export class MonitoringScope {
  static USER_DIGITAL_ID = 'USER_DIGITAL_ID';

  static get scope() {
    const curr = window[MONITORING_SCOPE];
    if (!curr) {
      window[MONITORING_SCOPE] = {};
      return window[MONITORING_SCOPE];
    }
    return curr;
  }

  static get(key) {
    if (!this.scope) {
      return undefined;
    }
    return this.scope[key];
  }

  static set(key, value) {
    this.scope[key] = value;
  }

  static patch(obj) {
    this.scope = {
      ...this.scope,
      ...obj,
    };
  }
}
